import { Menu } from 'antd'
import { editAction, itemsActions } from './constants'
import Typography from '../../../../../../components/Typography/Typography'
import { TMenuItems } from './types'
import { routes } from '../../../../../../router'
import useRouter from '../../../../../../hooks/useRouter'
import { HOSPITAL_STATUSES } from '../../../../../../constants'
import { useMemo } from 'react'
import { ability, ACTIONS, SUBJECTS } from '../../../../../Permission'

export const MenuItems = ({
  setVisible,
  row,
  handleSelectRow,
  setOpenArchivePopup,
  hsId,
  setOpenActivatePopup,
  outsideCommunityMode
}: TMenuItems) => {
  const { navigate } = useRouter()
  const handleArchive = () => {
    handleSelectRow([row.uuid], [row])
    setOpenArchivePopup(true)
  }

  const handleReActivate = () => {
    handleSelectRow([row.uuid], [row])
    setOpenActivatePopup(true)
  }

  const canArchiveHospitals = ability.can(
    ACTIONS.ARCHIVE,
    SUBJECTS.HOSPITALS_IN_HS_DETAILS
  )

  const handleClick = (key: string) => {
    setVisible(false)
    switch (key) {
      case 'edit':
        return navigate(
          outsideCommunityMode
            ? `${routes.myCommunity}${routes.myOrganization}/hospitals/${row.uuid}`
            : `${routes.myCommunity}${routes.myOrganization}/health_systems/${hsId}/hospitals/${row.uuid}`
        )
      case 'archive':
        return handleArchive()
      case 're-activate':
        return handleReActivate()
      default:
        return
    }
  }

  const menuItems = useMemo(() => {
    if (!canArchiveHospitals) {
      return editAction
    } else if (row.status === HOSPITAL_STATUSES.ARCHIVED)
      return itemsActions.filter((item) => item.key !== 'archive')
    else return itemsActions.filter((item) => item.key !== 're-activate')
  }, [canArchiveHospitals, row.status])

  return (
    <Menu className="menu-items-wrapper">
      {menuItems.map((i) => (
        <Menu.Item key={i.key} onClick={() => handleClick(i.key)}>
          <Typography.Body1>{i.label}</Typography.Body1>
        </Menu.Item>
      ))}
    </Menu>
  )
}
